module.exports = __webpack_public_path__ + "img/xindai_step1.e5a1166c.png";